// src/pages/Accounting/Reports/AccountList/components/ErrorState.tsx

import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  onRetry: () => void;
}

export default function ErrorState({ onRetry }: ErrorStateProps) {
  return (
    <div className="py-16 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 text-[#B33E1A] mb-3">
        <AlertCircle size={48} strokeWidth={1.5} />
      </div>
      <h4 className="text-[15px] font-bold text-ink m-0 mb-1.5">Report couldn't load</h4>
      <p className="text-[12.5px] text-ink3 m-0 mb-4 max-w-[280px] mx-auto">
        Something went wrong on our side. Try again in a moment.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="bg-teal-dark text-white text-[12px] font-bold px-4 py-2 rounded-md border-none cursor-pointer hover:brightness-110"
      >
        Try again
      </button>
    </div>
  );
}